export default __webpack_public_path__ + "static/media/icon-ig_white.9829a146.svg";